import { ComponentItem } from "designSystem/types/component-item-types";
import { ChipArray, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="ChipArray Outlined" />
			<ChipArray<ComponentItem>
				items={items}
				name="City Name"
				variant="outlined"
			/>
			<Text semiBold text="ChipArray default" />
			<ChipArray<ComponentItem>
				items={items}
				name="City Name"
			/>
			<Text semiBold text="ChipArray default without name" />
			<ChipArray<ComponentItem>
				items={items}
				name=""
			/>
		</CssColumnGrid>
	);
};